import React from "react";
import { Link, useLocation } from "react-router-dom";
import navLinks from "../data/navLinks";
import AdBlock from "./adblock";

const Footer = ({ footerText }) => {
  const location = useLocation();
  const currentType = navLinks.find(link => location.pathname.includes(link.to))?.type;
  const filtered = navLinks.filter(link => link.type === currentType && !location.pathname.includes(link.to));
  const random = filtered.sort(() => 0.5 - Math.random()).slice(0, 3);

  return (
    <footer className="footer">
      {currentType && random.length > 0 && (
        <div className="footer-suggestions">
          {typeof window !== "undefined" && <AdBlock />}
          <h4>{currentType === "dev" ? "More Developer Tools" : "You May Also Like:"}</h4>
          <ul>
            {random.map(link => (
              <li key={link.to}>
                <Link to={link.to} className="footer-link-item">
                  <span className="footer-icon">{link.icon || "🔧"}</span>
                  <div>
                    <strong>{link.label}</strong>
                    <div className="footer-desc">{link.desc || "Useful utility tool."}</div>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
      <p id="footer">{footerText}</p>
      <div className="footer-links">
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/terms">Terms</Link>
        <Link to="/contact">Contact</Link>
      </div>
    </footer>
  );
};

export default Footer;